var DependentFormDataTestIdEnum = /* @__PURE__ */ ((DependentFormDataTestIdEnum2) => {
  DependentFormDataTestIdEnum2["DEPENDENT_FORM_DOCUMENT_NUMBER_INPUT"] = "dependent-form-document-number-input";
  DependentFormDataTestIdEnum2["DEPENDENT_FORM_LEGAL_NAME_INPUT"] = "dependent-form-legal-name-input";
  DependentFormDataTestIdEnum2["DEPENDENT_FORM_SOCIAL_NAME_INPUT"] = "dependent-form-social-name-input";
  DependentFormDataTestIdEnum2["DEPENDENT_FORM_INCLUDE_SOCIAL_NAME_BUTTON"] = "dependent-form-include-social-name-button";
  DependentFormDataTestIdEnum2["DEPENDENT_FORM_BIRTHDAY_INPUT"] = "dependent-form-birthday-input";
  DependentFormDataTestIdEnum2["DEPENDENT_FORM_GENDER_FIELD"] = "dependent-form-gender-field";
  DependentFormDataTestIdEnum2["DEPENDENT_FORM_GENDER_FEMALE_RADIO"] = "dependent-form-gender-female-radio";
  DependentFormDataTestIdEnum2["DEPENDENT_FORM_GENDER_MALE_RADIO"] = "dependent-form-gender-male-radio";
  DependentFormDataTestIdEnum2["DEPENDENT_FORM_GENDER_NONBINARY_RADIO"] = "dependent-form-gender-nonbinary-radio";
  DependentFormDataTestIdEnum2["DEPENDENT_FORM_GENDER_NOT_INFORMED_RADIO"] = "dependent-form-gender-not-informed-radio";
  DependentFormDataTestIdEnum2["DEPENDENT_FORM_SUBMIT_BUTTON"] = "dependent-form-submit-button";
  DependentFormDataTestIdEnum2["DEPENDENT_FORM_BACK_BUTTON"] = "dependent-form-back-button";
  return DependentFormDataTestIdEnum2;
})(DependentFormDataTestIdEnum || {});
export {
  DependentFormDataTestIdEnum
};
